import { ALL_CATEGORY_SLUGS } from '../config/categories'

// CATEGORY_WHITELIST: valid category URL roots for product/category routing.
// The source list is derived from app/category/categoryConfig.ts.
export const CATEGORY_WHITELIST = new Set(ALL_CATEGORY_SLUGS)

export const EUROPEAN_COUNTRIES = [
  'AL',
  'AD',
  'AT',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'LV',
  'LI',
  'LT',
  'LU',
  'MK',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'UA',
  'VA',
  'GB',
  'UK',
] as const

export const isEuropeanCountry = (countryCode: string): boolean => {
  return EUROPEAN_COUNTRIES.includes(countryCode.toUpperCase() as any)
}
